import { styled } from 'styled-components';

import { ReactComponent as BinIcon } from 'src/resources/bin.svg';
import { ReactComponent as CartIcon } from 'src/resources/cart.svg';
import { ReactComponent as EditIcon } from 'src/resources/edit.svg';
import { colorNeutral, colorSecondary400Tint, colorSecondary800, colorSecondary900 } from 'src/styles/colors';
import { changeIconFillColor, changeIconStrokeColor } from 'src/styles/mixins';

import { IconTheme } from './icon-theme';

interface IconColor {
  normal: string;
  disabled: string;
  hover: string;
}

export const iconColors: Record<IconTheme, IconColor> = {
  [IconTheme.LIGHT]: {
    normal: colorNeutral,
    disabled: colorSecondary400Tint,
    hover: colorNeutral,
  },
  [IconTheme.DARK]: {
    normal: colorSecondary900,
    disabled: colorSecondary400Tint,
    hover: colorSecondary800,
  },
};

interface StyledIconProps {
  $disabled?: boolean;
  $iconTheme: IconTheme;
}

const getIconColor = (type: IconTheme, disabled?: boolean) =>
  disabled ? iconColors[type].disabled : iconColors[type].normal;

export const StyledCartIcon = styled(CartIcon)<StyledIconProps>`
  ${(props) => changeIconFillColor(getIconColor(props.$iconTheme, props.$disabled))};
`;

export const StyledBinIcon = styled(BinIcon)<StyledIconProps>`
  ${(props) => changeIconStrokeColor(getIconColor(props.$iconTheme, props.$disabled))};
`;

export const StyledEditIcon = styled(EditIcon)<StyledIconProps>`
  ${(props) => changeIconFillColor(getIconColor(props.$iconTheme, props.$disabled))};
`;
